export const defaultConsole = {
    log: console.log,
    info: console.info,
    error: console.error,
    warn: console.warn,
}
